import type { StatusTone } from './primitives.types';

/**
 * `StatusBadge` border (`color`) and label (`textColor`) shades per status tone. The label darkens for
 * contrast where the border shade is under 4.5:1 on white; the border keeps the status colour itself.
 */
export const STATUS_TONE_COLORS: Record<StatusTone, { color: string; textColor: string }> = {
	success: { color: 'teal.8', textColor: 'teal.9' },
	warning: { color: 'orange.6', textColor: 'orange.7' },
	accent: { color: 'blue.6', textColor: 'blue.6' },
	error: { color: 'red.6', textColor: 'red.7' },
	dark: { color: 'dark.4', textColor: 'dark.4' },
	muted: { color: 'gray.4', textColor: 'dark.4' },
	neutral: { color: 'gray.6', textColor: 'dark.4' },
};
